<template>
  <div class="about">
    <Nav></Nav>
    <div class="home-box">
      <div class="home-inner">
        <div
          v-if="bannerList && bannerList.length"
          class="swiper-container banner-box"
          v-swiper:mySwiper2="swiperBannerOption"
        >
          <div class="swiper-wrapper">
            <div
              v-for="(item, idx) in bannerList"
              :key="idx"
              class="swiper-slide"
            >
              <img :src="item.img_4_page_link_wc" alt="" />
            </div>
          </div>
        </div>
        <!-- <img src="../assets/banner.png" alt="" /> -->
        <div class="about-box">
          <div class="title">关于我们</div>
          <div class="subtitle">About Us</div>
          <div class="aboutus-text">
            <span class="special"
              >独自开信息科技（上海）有限公司是一个拥有独立研发实力的技术团队。</span
            ><br />我们秉承<span class="special">独立、自由、开放</span
            >的团队价值观，<br />坚守长期主义，<br />始终聚焦商品与服务交易的全流程，<br />建设一个<span
              class="special"
              >独立、自由、开源</span
            >的PaaS平台。<br />期待各路程序员加入我们的平台，<br />一起创造一个新的世界，<br />在这里每一个人都被尊重，<br />每一个灵魂都应该拥有自己的思想。
          </div>
        </div>
        <div class="qrcode-box">
          <div class="swiper-container" v-swiper:mySwiper="swiperOption">
            <div class="swiper-wrapper">
              <div
                v-for="(item, idx) in qrcodeList"
                :key="idx"
                class="swiper-slide"
              >
                <div class="qrcode-show-box">
                  <img class="qrcode-img" :src="item.icon" alt="qrcode" />
                </div>
                <div class="qrcode-text-box">
                  <div class="tip">扫码关注</div>
                  <div class="qrcode-text">{{ item.text }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ourlife-box">
          <div class="title">我们的理想生活</div>
          <div class="subtitle">Our Ideal Life</div>
          <div class="lifeimg-box">
            <img class="life-img" src="../assets/life-1.jpg" alt="life" />
            <img class="life-img" src="../assets/life-2.jpg" alt="life" />
            <img class="life-img" src="../assets/life-3.jpg" alt="life" />
            <img class="life-img" src="../assets/life-4.jpg" alt="life" />
            <img class="life-img" src="../assets/life-5.jpg" alt="life" />
            <img class="life-img" src="../assets/life-6.jpg" alt="life" />
            <img class="life-img" src="../assets/life-7.jpg" alt="life" />
            <img class="life-img" src="../assets/life-8.jpg" alt="life" />
            <img class="life-img" src="../assets/life-9.jpg" alt="life" />
            <img
              v-if="showTopIcon"
              class="top-btn"
              src="../assets/btn-totop.png"
              alt="btn-totop"
              @click.stop="goTop"
            />
          </div>
        </div>
        <div class="register-box" v-if="!userInfo">
          <div>自由通道，点击注册或者登陆</div>
          <div class="buttons-box">
            <el-button
              class="custom-button btn-17151c btn-tologin"
              @click="handleToLogin"
              >登录</el-button
            >
            <el-button
              class="custom-button btn-ff3333 btn-toreg"
              @click="handleToReg"
              >注册</el-button
            >
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
    <ButtonFeedback></ButtonFeedback>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import ButtonFeedback from "@/components/ButtonFeedback";
import pageCommon from "@/utils/pagecommon";
import absoutApi from "@/api/about";
export default {
  name: "About",
  components: {
    Swiper,
    SwiperSlide,
    Nav,
    Footer,
    ButtonFeedback
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      bannerList: [],
      qrcodeList: [],
      swiperOption: {
        loop: true,
        autoplay: {
          duration: 3000,
        },
      },
      swiperBannerOption: {
        loop: false,
        observer: true,
        autoHeight: true,
        autoplay: false
      },
      showTopIcon: false,
    };
  },
  computed: {
    userInfo: function () {
      let _this = this;
      let user = _this.$store.state.user;
      return user;
    },
  },
  methods: {
    getAboutBanner: function () {
      let _this = this;
      pageCommon
        .apiRequestCommon(absoutApi, "getAboutBanner", { isloading: false })
        .then(
          (res) => {
            _this.bannerList = res.page_content;
          },
          (err) => {
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
              _this.bannerList = [];
            } else {
              _this.$message.error(err.data.msg);
              _this.bannerList = [];
            }
          }
        );
    },
    getQrcodes: function () {
      let _this = this;
      pageCommon
        .apiRequestCommon(absoutApi, "getQrcodeList", { isloading: false })
        .then(
          (res) => {
            let list = [];
            for (let index = 0; index < res.page_content.length; index++) {
              const element = res.page_content[index];
              list.push({
                text: element.title_4_page_link_wc,
                icon: element.img_4_page_link_wc,
              });
            }
            _this.qrcodeList = list;
          },
          (err) => {
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
              _this.qrcodeList = [];
            } else {
              _this.$message.error(err.data.msg);
              _this.qrcodeList = [];
            }
          }
        );
    },
    handleToLogin: function () {
      let _this = this;
      _this.$router.push("/login");
    },
    handleToReg: function () {
      let _this = this;
      _this.$router.push("/register");
    },
    showToTop: function () {
      let _this = this;
      if (
        !!document.documentElement.scrollTop &&
        document.documentElement.scrollTop > 3000
      ) {
        _this.showTopIcon = true;
      } else {
        _this.showTopIcon = false;
      }
    },
    goTop() {
      cancelAnimationFrame(this.timer);
      const self = this;
      self.timer = requestAnimationFrame(function fn() {
        const oTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        if (oTop > 0) {
          document.body.scrollTop = document.documentElement.scrollTop =
            oTop - 50;
          self.timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(self.timer);
        }
      });
    },
  },
  mounted() {
    let _this = this;
    _this.$store.dispatch("acNavIndex", 2);
    window.addEventListener("scroll", _this.showToTop);
    _this.getAboutBanner();
    setTimeout(() => {
      _this.getQrcodes();
    }, 1000)
  },
  destroyed() {
    let _this = this;
    window.removeEventListener("scroll", _this.showToTop);
  },
};
</script>

<style scoped lang="less">
@import "../assets/css/common.less";
.about {
  overflow: hidden;
  .home-box {
    width: 100%;
    color: #ffffff;
    font-size: 30px;
    overflow: hidden;

    .home-inner {
      min-width: 1200px;
      padding-top: 80px;
      height: 100%;
      margin: 0 auto;
      overflow: hidden;
      box-sizing: border-box;
      .title {
        width: 100%;
        font-size: 40px;
        font-family: "SourceHanSansCN";
        color: rgb(34, 34, 34);
        font-weight: bold;
        line-height: 0.5;
        text-align: center;
      }
      .subtitle {
        width: 100%;
        font-size: 20px;
        font-family: "SourceHanSansCN";
        color: rgb(153, 153, 153);
        line-height: 1;
        text-align: center;
        margin-top: 25px;
      }
      img {
        width: 100%;
        height: 100%;
        vertical-align: top;
      }
      .banner-box {
        position: relative;
        width: 100%;
        .swiper-wrapper {
          position: relative;
          width: 100%;
        }
        img {
          display: block;
          height: 100%;
          margin: 0 auto;
        }
      }
      .about-box {
        position: relative;
        margin-top: 120px;
        .aboutus-text {
          margin-top: 80px;
          text-align: center;

          font-size: 20px;
          font-family: "SourceHanSansCN";
          color: rgb(0, 0, 0);

          line-height: 40px;
          .special {
            font-weight: bold;
          }
        }
      }
      .qrcode-box {
        position: relative;
        width: 608px;
        height: 327px;
        background: url("../assets/bg-qrcode1.png") no-repeat;
        background-size: 100% 100%;
        margin: 160px auto 0;

        .swiper-container {
          position: absolute;
          width: 567px;
          height: 327px;
          top: 0;
          left: 50%;
          transform: translate(-50%, 0);
          .swiper-wrapper {
            position: relative;
            width: 100%;
            height: 100%;
            .swiper-slide {
              width: 100%;
              height: 100%;
              display: flex;
              // flex-direction: column;
              // align-items: center;
              // justify-content: center;
              .qrcode-show-box {
                position: relative;
                width: 238px;
                height: 238px;
                background: url(../assets/bg-qrcode.png) no-repeat;
                background-size: 100% 100%;
                margin-left: 65px;
                margin-top: 47px;
                .qrcode-img {
                  position: absolute;
                  width: 232px;
                  height: 232px;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                }
              }
              .qrcode-text-box {
                flex: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
                // justify-content: center;
                // margin-top: 173px;
                font-size: 20px;
                font-family: "AlibabaPuHuiTiB";
                color: rgb(255, 255, 255);
                line-height: 20px;
                .tip {
                  position: relative;
                  // width: 80px;
                  font-size: 20px;
                  font-family: "AlibabaPuHuiTiR";
                  color: rgb(7, 6, 11);
                  line-height: 20px;
                  font-weight: 700;
                  margin-top: 130px;

                  box-sizing: border-box;
                }
                .qrcode-text {
                  position: relative;
                  height: 32px;
                  line-height: 32px;
                  padding-left: 10px;
                  padding-right: 10px;
                  background: #000000;
                  border-radius: 4px;
                  font-weight: 700;
                  margin-top: 25px;
                }
              }
              .overlayscene-icon {
                display: block;
                width: 86px;
                height: auto;
                // height: 74px;
              }
              .overlayscene-text {
                position: relative;
                height: 30px;
                line-height: 30px;
                padding-left: 10px;
                padding-right: 10px;
                border: 1px solid rgb(34, 34, 34);
                color: #000000;
                font-size: 16px;
                font-family: "SourceHanSansCN";
                color: rgb(34, 34, 34);
                box-sizing: border-box;
                margin-top: 20px;
                font-weight: 700;
              }
            }
          }
        }
      }
      .ourlife-box {
        position: relative;
        margin-top: 160px;
        padding-bottom: 80px;
        .lifeimg-box {
          position: relative;
          width: 1200px;
          margin: 80px auto;
          .life-img {
            width: 1200px;
            // margin: 0 auto;
            // display: block;
          }
          .top-btn {
            position: fixed;
            width: 82px;
            height: 82px;
            // right: -102px;
            // right: 0;
            bottom: 400px;
            cursor: pointer;
            transform: translateX(10px);
          }
        }
      }
      .register-box {
        position: relative;
        width: 100%;
        font-size: 32px;
        line-height: 32px;
        font-family: "SourceHanSansCN";
        color: rgb(34, 34, 34);
        font-weight: bold;
        padding-bottom: 80px;
        text-align: center;
        .buttons-box {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 65px;
          .btn-tologin,
          .btn-toreg {
            width: 176px;
            height: 58px;
            line-height: 58px;
            font-size: 20px;
          }
          .button {
            width: 176px;
            height: 58px;
            line-height: 58px;
            border-radius: 4px;

            text-align: center;
            box-sizing: border-box;
            margin-left: 50px;

            font-size: 20px;
            font-family: "SourceHanSansCN";
            color: rgb(255, 255, 255);
            font-weight: bold;

            cursor: pointer;
            &.black {
              background-color: rgb(7, 6, 11);
              &:hover {
                background-color: rgb(69, 68, 71);
              }
              &:active {
                background-color: rgb(24, 20, 30);
              }
            }
            &.red {
              background-color: rgb(233, 64, 67);
              &:hover {
                background-color: rgb(239, 103, 101);
              }
              &:active {
                background-color: rgb(239, 103, 101);
              }
            }
            &:first-child {
              margin-left: 0;
            }
          }
        }
      }
    }
  }
}
</style>
